import { MenuIdInsight } from '@jira/navigation-apps__constants/src/MenuIdInsight.tsx';
import { serviceDeskAssetsImportTypeForgeDataResource } from '@jira/router-resources__assets-import-type-forge-data/src/serviceDeskAssetsImportTypeForgeDataResource.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCmdbAssetsObjectSchemaConfigurationRoute } from '@jira/router-routes__servicedesk-cmdb-routes/src/servicedeskCmdbAssetsObjectSchemaConfigurationRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getCmdbResources } from './common/getCmdbResources.tsx';
import ObjectSchemaConfiguration, {
	LazyServicedeskCmdbObjectSchemaConfiguration,
} from './ui/object-schema-configuration/index.tsx';
import { AssetsAppRedirect } from './ui/redirect/assets-app-redirect/index.tsx';

export const servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry: Route = createEntry(
	servicedeskCmdbAssetsObjectSchemaConfigurationRoute,

	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MenuIdInsight },
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_as_an_app_v2') ? AssetsAppRedirect : ObjectSchemaConfiguration,
		resources: [...getCmdbResources(), serviceDeskAssetsImportTypeForgeDataResource],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskCmdbObjectSchemaConfiguration],
		perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',

		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_GLOBAL_CONFIGURATION,
				packageName: toPackageName(APP_NAMES.INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
				teamName: 'krispy-krew',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
